/**
 * Default page chrome: `pages/_app.page.tsx`'s fallback `getLayout` — the branch
 * every page without its own `getLayout` took — as a pathless layout route. The
 * underscore keeps it out of the URL; `_dashboard/dashboard.tsx` still serves
 * `/dashboard`. Pages that set `Page.getLayout` under Next aren't children here;
 * they render their own wrapper, and no shared opt-out convention remains.
 *
 * Must stay a route, not a per-page HOC: `MyApp` ran `getLayout` every render, so
 * `<DashboardLayout>` held a fixed tree position and survived navigation. An HOC
 * gives each page its own wrapper type, so React rebuilds the shell on every
 * navigation — losing, among other things, a collapsed `Drawer`.
 */
import { Box } from "@mui/material";
import { Outlet, createFileRoute } from "@tanstack/react-router";

import DashboardLayout from "@/components/navigation/DashboardLayout";

export const Route = createFileRoute("/_app/_dashboard")({
  component: DashboardChrome,
});

function DashboardChrome() {
  return (
    <DashboardLayout>
      <Outlet />
      <Box height={90} />
    </DashboardLayout>
  );
}
